import type * as lazyIndex from './lazyIndex';
import {
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
    LazyImport,
    LazyAction,
} from 'owa-bundling';
import { initializeSharedFolderRoots } from 'owa-folders';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/*webpackChunkName: "SharedFolders"*/ './lazyIndex'),
    { name: 'SharedFolders' }
);

export const LazySharedFolderPeoplePicker: typeof lazyIndex.SharedFolderPeoplePicker =
    createLazyComponent(lazyModule, m => m.SharedFolderPeoplePicker);
export const lazyShowSharedFolderPeoplePickerDialog: LazyAction<
    typeof lazyIndex.showSharedFolderPeoplePickerDialogMutator,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.showSharedFolderPeoplePickerDialogMutator);

export const lazyRemoveSharedFolderUser: LazyImport<
    typeof lazyIndex.removeSharedFolderUser,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.removeSharedFolderUser);
export const lazyAddSharedFolderUser: LazyAction<
    typeof lazyIndex.addSharedFolderUser,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.addSharedFolderUser);
export const lazyAddImportedAdditionalMailboxes: LazyAction<
    typeof lazyIndex.addImportedAdditionalMailboxes,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.addImportedAdditionalMailboxes);
export const lazyInitializeSharedFolderRetentionPolicyTags: LazyAction<
    typeof lazyIndex.initializeSharedFolderRetentionPolicyTags,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.initializeSharedFolderRetentionPolicyTags);
export const lazySetSharedFolderMatchesAccount: LazyAction<
    typeof lazyIndex.setSharedFolderMatchesAccountMutator,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.setSharedFolderMatchesAccountMutator);

export const lazySetSharedFolderIsHidden: LazyAction<
    typeof lazyIndex.setSharedFolderIsHiddenMutator,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.setSharedFolderIsHiddenMutator);

registerLazyOrchestrator(
    initializeSharedFolderRoots,
    lazyModule,
    m => m.initializeSharedFolderRootsOrchestrator
);

export { selectDefaultFolderOnRemove } from './actions/selectDefaultFolderOnRemove';
